import * as Icons from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "../data";

export const Services = ({ showHeader = true }) => (
  <section id="services" className="py-24 lg:py-32 bg-[var(--paper)]" data-testid="services">
    <div className="max-w-7xl mx-auto px-6">
      {showHeader && (
        <div className="max-w-2xl mb-16">
          <Reveal><Overline>Services</Overline></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-[var(--primary)]">More than a flight school.</h2></Reveal>
          <Reveal delay={0.15}><p className="mt-5 text-[var(--muted)] text-base md:text-lg">Everything you need to train efficiently and comfortably — all in one place at Rand Airport.</p></Reveal>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Plane;
          return (
            <Reveal key={s.title} delay={i * 0.1}>
              <div className="group h-full rounded-2xl bg-white border border-[var(--line)] p-8 card-shadow hover:-translate-y-2 transition-transform duration-500" data-testid={`service-card-${i}`}>
                <div className="h-14 w-14 rounded-2xl bg-navy flex items-center justify-center group-hover:bg-accent-c transition-colors duration-500"><Icon className="text-accent-2 group-hover:text-white transition-colors duration-500" size={26} /></div>
                <h3 className="mt-6 font-display text-lg font-semibold text-[var(--primary)]">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{s.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
